import { getEnvConfig } from 'config/environment';

export const isStandalone = () => {
  return getEnvConfig().REACT_APP_STANDALONE_DEMO === 'true';
};
